module.exports = __webpack_public_path__ + "img/dots.1d680966.svg";